import { LEVEL_COLORS, STATUS } from "./texts";

const Tile = ({ label, keyName, lang }) => {
  const st = STATUS[keyName];
  const [text, dot] = LEVEL_COLORS[st.level];
  return (
    <div className="hc-tile hc-neu">
      <span className="hc-tile-l"><i className="hc-dot" style={{ backgroundColor: dot }} />{label}</span>
      <span className="hc-tile-s" style={{ color: text }}>{st[lang]}</span>
    </div>
  );
};

export const RefPanels = ({ T, lang, scan, onConfirm }) => {
  return (
    <>
      <div className="hc-info">
        <div className="hc-L hc-liveinfo">
          <div className="hc-tiles">
            <Tile label={T.lighting} keyName={scan.result.lighting} lang={lang} />
            <Tile label={T.distance} keyName={scan.result.distance} lang={lang} />
            <Tile label={T.stability} keyName={scan.result.stability} lang={lang} />
          </div>
        </div>
        <div className="hc-R hc-ready hc-neu">
          <span className="hc-gc">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" /><path d="m9 12 2 2 4-4" /></svg>
          </span>
          <span><b>{T.readyTitle}</b><small>{T.readySub}</small></span>
        </div>
      </div>
      <div className="hc-actions">
        <button type="button" className="hc-L hc-primary" disabled={!scan.ready && !scan.allowManual} onClick={scan.capture} data-testid="refcam-capture">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01" /></svg>
          {T.capture}
        </button>
        <div className="hc-R hc-revacts">
          <button type="button" className="hc-secondary hc-neu" onClick={scan.retake} data-testid="refcam-retake">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#222A35" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /></svg>
            {T.retake}
          </button>
          <button type="button" className="hc-primary" disabled={!scan.photo} onClick={() => scan.photo && onConfirm(scan.photo.blob)} data-testid="refcam-approve">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
            {T.approve}
          </button>
        </div>
      </div>
    </>
  );
};
